import React, { useEffect, useState } from "react";
import "../styles/Cargo.scss";

const RobinhoodCoins = [
    {symbol : "DOGEUSDT", icon : "/doge.png"},
    {symbol : "SHIBUSDT", icon : "/shib.png"},
    {symbol : "UNIUSDT", icon : "/uni.png"},
     {symbol : "UNIUSDT", icon : "/uni.png"},
    {symbol : "AVAXUSDT", icon : "/avax.png"},
    {symbol : "TRXUSDT", icon : "/trx.png"},
    {symbol : "ATOMUSDT", icon : "/atom.png"},
    {symbol : "DOGEUSDT", icon : "/doge.png"},
    {symbol : "SHIBUSDT", icon : "/shib.png"},
    {symbol : "UNIUSDT", icon : "/uni.png"},
    {symbol : "AVAXUSDT", icon : "/avax.png"},
    {symbol : "TRXUSDT", icon : "/trx.png"},
    {symbol : "SHIBUSDT", icon : "/shib.png"},
    {symbol : "UNIUSDT", icon : "/uni.png"},
    {symbol : "AVAXUSDT", icon : "/avax.png"},
    {symbol : "TRXUSDT", icon : "/trx.png"},
    {symbol : "ATOMUSDT", icon : "/atom.png"},
    {symbol : "DOGEUSDT", icon : "/doge.png"},
    {symbol : "SOLUSDT", icon : "/shib.png"},
    {symbol : "SHIBUSDT", icon : "/shib.png"},
    {symbol : "UNIUSDT", icon : "/uni.png"},
    {symbol : "AVAXUSDT", icon : "/avax.png"},
    {symbol : "TRXUSDT", icon : "/trx.png"},
    {symbol : "ATOMUSDT", icon : "/atom.png"},
];
const BybitCoins = [
    {symbol : "DOGEUSDT", icon : "/doge.png"},
    {symbol : "SHIBUSDT", icon : "/shib.png"},
    {symbol : "UNIUSDT", icon : "/uni.png"},
     {symbol : "UNIUSDT", icon : "/uni.png"},
    {symbol : "AVAXUSDT", icon : "/avax.png"},
    {symbol : "TRXUSDT", icon : "/trx.png"},
    {symbol : "ATOMUSDT", icon : "/atom.png"},
    {symbol : "DOGEUSDT", icon : "/doge.png"},
    {symbol : "SHIBUSDT", icon : "/shib.png"},
    {symbol : "UNIUSDT", icon : "/uni.png"},
    {symbol : "AVAXUSDT", icon : "/avax.png"},
    {symbol : "TRXUSDT", icon : "/trx.png"},
    {symbol : "SHIBUSDT", icon : "/shib.png"},
    {symbol : "UNIUSDT", icon : "/uni.png"},
    {symbol : "AVAXUSDT", icon : "/avax.png"},
    {symbol : "TRXUSDT", icon : "/trx.png"},
    {symbol : "ATOMUSDT", icon : "/atom.png"},
    {symbol : "DOGEUSDT", icon : "/doge.png"},
    {symbol : "SOLUSDT", icon : "/shib.png"},
    {symbol : "SHIBUSDT", icon : "/shib.png"},
    {symbol : "UNIUSDT", icon : "/uni.png"},
    {symbol : "AVAXUSDT", icon : "/avax.png"},
    {symbol : "TRXUSDT", icon : "/trx.png"},
    {symbol : "ATOMUSDT", icon : "/atom.png"},
];

const Cargo = () => {
  const [selectedCoin, setSelectedCoin] = useState(null);


  return (
    <div className="table-container">
      <div className="filter-topbar">
        <button className="liveMarket active" type="button">
          Locomotiv ~ Ai Engine
        </button>
        <img
          className="filter-separator"
          src="https://cdn-eu.icons8.com/docs/V443pG6c4020pcGKhAhMcg/fcxRd1SSekaYK--CZcD2CA.svg"
          alt="separator"
          width={24}
          height={36}
          aria-hidden="true"
          draggable={false}
        />
        <button className="robinhood" type="button" title="Show only Robinhood coins">
          <img
            src="/dollar.png"
            alt="RH"
            className="filter-icon"
            width={24}
            height={45}
            draggable={false}
          />
        </button>
        <img
          className="filter-separator"
          src="https://cdn-eu.icons8.com/docs/V443pG6c4020pcGKhAhMcg/fcxRd1SSekaYK--CZcD2CA.svg"
          alt="separator"
          width={24}
          height={36}
          aria-hidden="true"
          draggable={false}
        />
        <button className="highGains" type="button" title="Show only high gainers">
          <img
            src="/shutdown.png"
            alt="High Gains"
            className="filter-icon"
            width={47}
            height={45}
            draggable={false}
          />
        </button>
        <div className="timeupdated">last updated 12:00 PM</div>
        <div className="ailiveEngine">
          <img src="/enginelive.png" alt="" />
        </div>
        <span className="status">Ai Engine <br />Live</span>

      </div>

      <div className="main-header">
        <div className="allcoins">Cargo</div>
      </div>

      
      <div className="progress">
        <div className="cargoIcon">
          <img src="/cargo.png" alt="" />
        </div>
        <div className="progress-text">
          Total Coins
          <div className="percentage">
            100
          </div>
        </div>
        <div className="line3">
          <img src="/line3.png" alt="" />
        </div>
        <div className="startTime">
          Robinhood
          <div className="time">
            24
          </div>
        </div>
        <div className="line4">
          <img src="/line4.png" alt="" />
        </div>
        <div className="finishTime">
          Bybit
          <div className="time">
            70
          </div>
        </div>
        <div className="redicon">
            <img src="/redIcon.png" alt="" />
        </div>
      </div>
      
         <div className="robinhoodEst">
            Robinhood
            <img src="/searchIcon.png" alt="" />
         </div>
        <div className="robinhoodCoinsList">
          {RobinhoodCoins.map((coin, index) => (
            <div className="coin">
              <div
                className={`bgcoin${selectedCoin === coin.symbol ? " selected" : ""}`}
                key={index}
                onClick={() => setSelectedCoin(coin.symbol)}
               >
                  <img src={coin.icon} alt={coin.symbol} />
                  <span className="coinSymbols">{coin.symbol}</span>
                </div>
            </div>
            
          ))}
        </div>

         <div className="bybitEst">
          Bybit
         </div> 
        <div className="bybitCoinsList">
          {BybitCoins.map((coin, index) => (
            <div className="coin">
              <div
                className={`bgcoin${selectedCoin === coin.symbol ? " selected" : ""}`}
                key={index}
                onClick={() => setSelectedCoin(coin.symbol)}
               >
                  <img src={coin.icon} alt={coin.symbol} />
                  <span className="coinSymbols">{coin.symbol}</span>
                </div>
            </div>
            
          ))}
        </div>

      <div className="space"></div>
    </div>
  );
};

export default Cargo;